import React from 'react';

export default function FileTypeWordIcon() {
    return <svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M7.98964 0.23L6.20764 5H5.37964L4.00264 1.382L2.60764 5H1.77964L0.00663672 0.23H0.825637L2.21164 4.028L3.65164 0.23H4.38064L5.79364 4.046L7.21564 0.23H7.98964Z" fill="#388FFB"/> </svg>;
};